import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconErrorCircle = ({ t, fill, className, height, width }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox='0 0 24 24'
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    <path d='M0 0h24v24H0z' fill='none' />
    <path fill={fill} d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' />
  </svg>
)

export default Icon(IconErrorCircle)
